import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApproveModel } from './approve.model';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApproveService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
      const base =
        this.authService.getOriginCurrency() !== 'BRL'
          ? environment.intlUrl   
          : environment.apiUrl;

      return `${base}${path}`;
  }

  public getPendingWithdraw()
  {
    return this.http.get<ApproveModel[]>(this.url('/getPendingWithdraw'));
  }

  public approveOrNotWithdraw(ids: string[], isApproved: boolean, code2FA: string)
  {
    return this.http.post(this.url('/approveWithdraw'), {ids,isApproved,code2FA});
  }
}
